import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'
import React from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

import { Text } from '@/src/domains/design-system/components/Text'

const RegisterBenefits = () => {
  const { t } = getTranslate()
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Icon icon="flash" size="sm" color="primary" />
        <Text variant="sm" element="span">
          <Markdown>{t('registration.onlyPassword')}</Markdown>
        </Text>
      </div>
      <div className="flex items-center gap-3">
        <Icon icon="lock-alt" size="sm" color="primary" />
        <Text variant="sm" element="span">
          <Markdown>{t('registration.lock')}</Markdown>
        </Text>
      </div>
    </div>
  )
}

export default RegisterBenefits
